export type LineFormatType = 'normal' | 'ordered' | 'unordered';

export interface LineFormat {
  type: LineFormatType;
  content: string;        // Text without formatting markers
  indent: number;         // Number of leading spaces / 2
  listNumber?: number;    // For ordered lists
  rawLine: string;        // Original line with markers
}

export function parseTextLine(line: string): LineFormat {
  // Match ordered list: 1. Item, 2. Item, etc.
  const orderedMatch = line.match(/^(\s*)(\d+)\.\s+(.*)$/);
  if (orderedMatch) {
    const indent = Math.floor((orderedMatch[1]?.length ?? 0) / 2);
    const listNumber = Number.parseInt(orderedMatch[2] ?? '1', 10);
    return {
      type: 'ordered',
      content: orderedMatch[3] ?? '',
      indent,
      listNumber: Number.isNaN(listNumber) ? 1 : listNumber,
      rawLine: line,
    };
  }

  // Match unordered list: - Item or * Item
  const unorderedMatch = line.match(/^(\s*)([-*])\s+(.*)$/);
  if (unorderedMatch) {
    const indent = Math.floor((unorderedMatch[1]?.length ?? 0) / 2);
    return {
      type: 'unordered',
      content: unorderedMatch[3] ?? '',
      indent,
      rawLine: line,
    };
  }

  // Normal text (no formatting)
  const indent = Math.floor((line.match(/^\s*/)?.[0]?.length ?? 0) / 2);
  return {
    type: 'normal',
    content: line.trim(),
    indent,
    rawLine: line,
  };
}

export function formatLine(content: string, type: LineFormatType, indent = 0, listNumber?: number): string {
  const indentStr = '  '.repeat(indent);

  switch (type) {
    case 'ordered':
      return `${indentStr}${listNumber ?? 1}. ${content}`;
    case 'unordered':
      return `${indentStr}- ${content}`;
    case 'normal':
    default:
      return indentStr ? `${indentStr}${content}` : content;
  }
}

export function stripFormatting(line: string): string {
  const format = parseTextLine(line);
  return format.content;
}

export function getFontSizeMultiplier(_type: LineFormatType): number {
  return 1;
}

export function getFontWeight(_type: LineFormatType, baseWeight: 'normal' | 'bold'): 'normal' | 'bold' {
  return baseWeight;
}
